import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { Grid } from '@calendly/ui/components/grid'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'

import {
  GridWrapper,
  Footer,
  ActionsContainer,
  ClearButton,
  StyledSheet,
  StyledFixedContainer
} from './styles'

export const BaseFilterModal = ({ isOpen, onClose, onApply, onClear, children }) => {
  const isPhone = useDeviceType('isPhone')

  const FilterComponent = isPhone ? StyledFixedContainer : StyledSheet

  if (!isOpen) return null

  return (
    <FilterComponent aria-label="filter-modal">
      <GridWrapper>
        <Grid spacing={24}>
          {children}
        </Grid>
      </GridWrapper>
      <Footer>
        <ActionsContainer>
          <ClearButton decoration="minimal" onClick={onClear}>
            {isPhone ? I18n.t('publisher.action.reset') : I18n.t('publisher.meetings.filter_modal.reset')}
          </ClearButton>
          <Button onClick={onClose} responsive={false} decoration="secondary-outline">
            {I18n.t('publisher.action.cancel')}
          </Button>
          <Button onClick={onApply} responsive={false}>
            {I18n.t('publisher.action.apply')}
          </Button>
        </ActionsContainer>
      </Footer>
    </FilterComponent>
  )
}
